import type { IconProps } from '@/types/general'

export const CaretRight = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="currentColor"
    className={props.className}
  >
    <path
      d="M7.32756 19.0087C7.49048 19.1716 7.70339 19.2528 7.91673 19.2528C8.13006 19.2528 8.34297 19.1716 8.50589 19.0087L16.4226 11.092C16.748 10.7666 16.748 10.2391 16.4226 9.91366L8.50589 1.99699C8.18047 1.67158 7.65298 1.67158 7.32756 1.99699C7.00214 2.32241 7.00214 2.84991 7.32756 3.17533L14.6551 10.5028L7.32756 17.8303C7.00214 18.1557 7.00214 18.6832 7.32756 19.0087Z"
      fill="currentColor"
    />
  </svg>
)
